import { useContext } from "react";
import { Context } from "../../utils/main-context/MainContext";

import "./hero.scss";

const Hero = () => {
  const { heroActive } = useContext(Context);

  return (
    <section id="hero" className={heroActive ? "hero active" : "hero"}>
      <div className="container">
        <div className="hero-details">
          <p className="profession">front-end dev.</p>
          <div className="settlement">
            <span>living in</span>
            <span className="country">
              <span>Azerbaijan</span>
              <span>Baku</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
